/**
 * Booting the app.
 *
 * Nothing renders from a network response: IndexedDB is the source of truth and syncing
 * happens beside the UI rather than in front of it.
 */

import { render } from 'preact';

import './styles.css';
import { registerServiceWorker } from './pwa/register';
import { watchForUpdates } from './pwa/updates';
import { App } from './ui/app';

registerServiceWorker();
watchForUpdates();

const root = document.querySelector('#app');
if (root !== null) {
  render(<App />, root);
}
